import { render, staticRenderFns } from "./EtapaSimulacao.vue?vue&type=template&id=962ee396&scoped=true"
import script from "./EtapaSimulacao.vue?vue&type=script&lang=js"
export * from "./EtapaSimulacao.vue?vue&type=script&lang=js"
import style0 from "./EtapaSimulacao.vue?vue&type=style&index=0&id=962ee396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962ee396",
  null
  
)

export default component.exports